import React from 'react';

const Reports: React.FC = () => {
  return (
    <div>
      <h1>Reports</h1>
    </div>
  );
};

export default Reports;